import { FastSearchModule } from './../../blocks/ui-component/fast-search/fast-search.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersRoutingModule } from './users.routing';
import { UserService } from './user.service';
import { BlocksModule } from '../../blocks/blocks.module';
import { UserComponent } from './user.component';
import { UserListComponent } from './user-list.component';
//import { EqualValidator } from '../../shared/validation';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { UsersPrivilegesComponent } from '../userPrivilege/usersPrivileges.component';
import { PlacesComponent } from '../userPlaces/places.component';
import { AppCodesComponent } from '../appcodepermission/appcodes.component';
import { StepperModule } from '../../blocks/stepper/stepper.module';
import { UsersGroupsComponent } from '../usersGroups/usersGroups.component';
// import { MatchValueDirective } from '../../blocks/match-value/match-value.directive';


@NgModule({
    imports: [
        UsersRoutingModule,
        SharedModule,
        CommonModule,
        FormsModule,
        UsersPrivilegesComponent,
        PlacesComponent,
        AppCodesComponent,
        StepperModule,
        BlocksModule,
        UsersGroupsComponent,
        FastSearchModule
    ],
    exports: [
        UserComponent,
        UserListComponent
    ],
    declarations: [
        UserComponent,
        // MatchValueDirective,
        UserListComponent,
    ],
    providers: [UserService]
})
export class UsersComponent { }
